// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { PortfolioProjectEntry } from './ProjectCards.types';
import { Link } from 'react-router-dom';
import { AiOutlineExport } from 'react-icons/ai';
import { DateTime } from 'luxon';
import { Contentful } from '@brr-dev/contentful';

export type ProjectCardProps = {
    project: PortfolioProjectEntry;
    coverImage: Contentful.Asset;
};

export default function ProjectCard({ project, coverImage }: ProjectCardProps) {
    const link = project.fields.path ?? project.fields.link;
    const external = !project.fields.path;

    return (
        <Link to={link} target={external ? '_blank' : '_self'}>
            <div className="project-card">
                <img
                    className="project-card-cover"
                    alt={coverImage.fields.description}
                    src={coverImage.fields.file.url}
                />
                <div className="project-card-details">
                    <div className="project-card-title">
                        {project.fields.title ?? project.fields.name}
                        {external && (
                            <>
                                &nbsp;
                                <AiOutlineExport />
                            </>
                        )}
                    </div>
                    <div className="project-card-subtitle">{project.fields.subtitle}</div>
                    <div className="project-card-description">{project.fields.description}</div>
                    <div className="project-card-date">
                        {DateTime.fromFormat(project.fields.date, 'yyyy-MM-dd').toLocaleString(
                            DateTime.DATE_MED,
                        )}
                    </div>
                </div>
            </div>
        </Link>
    );
}
